import HelperFunctions from './functions';

const _subNavigationInitialData = {
  component: null,
  text: null,
  props: null,
  navigateAction: null,
  isCloseable: false,
  closeAction: null,
  isSingleton: true,
  isActive: false
};

class SubNavigationTab {
  constructor (data = _subNavigationInitialData) {
    this.id = HelperFunctions.uuidv4();

    this.component = data.component;
    this.text = data.text;
    this.props = data.props;

    this.navigateAction = data.navigateAction;

    this.isCloseable = data.isCloseable;
    this.closeAction = data.closeAction;

    this.isSingleton = data.isSingleton;
    this.isActive = data.isActive;
  }
}

export {
  SubNavigationTab
};
